//Provenir Grid Plugin

if(jQuery) (function($){
		function ProvGrid(container, options) {
			var _me = this;
			var _container = container;	  
			_container.data("provplugin", this);
			
			var defaults = {
					updateDivSelector: null,
					updateBusyDivSelector: null,
					sortUrl: null,
					showMoreUrl: null,
					sortParam: null,
					pageParam: null,
					sortOrderByParam: null,
					showMoreLinkSelector: null,
					alternateRowColors: true,
					doneCallback: null,
					onscrollObj: null,
					addButtonHtml: "",
					addButtonSelector: "",
					resize: false,					
					title: "",
					sort: false,
					highlight: false,
					height: "100%",
					moreRowText: "More",
					lessRowText: "",
					multicolumn: false,
					iconCreate: "",
					contentVisible: false,
					maxRowSize: null,
					hideContent: false,
					width: null,
					curSortField: null,
					curSortOrder: null,
					collapse: "no",
					prepend: false
			};	

			//Merge incoming options with defaults
			var _options = $.extend(defaults, options);
		
			//Plugin-level variables
			var _page = 1;
			var _showingMore = false;
			var _scrolled = 0;	//Scroll level
			
			this.onEnter = function(){
				if(_options.title!="")
				{
					_me.buildTitleBar();
				}
								
				_me.alternate();
				
				_container.addClass('ProvGrid');
				if (_options.width != null)
					_container.css('width', _options.width);

				if (_options.scroll != "no")	
					_container.css({
						'height': _options.height,
						'overflow':  "scroll"});
									
				// Make resizable
				if (_options.resize)
					_me.makeResizable();
				
				// Sortable binding				
				_me.makeSortable(_options.curSortField, _options.curSortOrder);			
					
				if (_options.highlight)					
					_me.makeHighlightable();
					
				if (_options.multicolumn){
					_me.multiColumn();
				}
				
				if (_options.hideContent){
					_me.hideContent();
				}
				
				if (_options.showMoreLinkSelector){
					_me.setShowMore();
				}
				
				if ((""+_options.addButtonHtml) != "" && (""+_options.addButtonSelector) != "") {
					_me.bindAddButton();					
				}
				
				_me.bindExpandButtons();
				
				_me.doneLoading();
				
				$(window).resize(function() {
					_me.onResize();
				});
				_me.onResize();
			};

			this.onResize = function() {
				var tableWidth = ( _container.find("table").width() );
				
				$(".pgOFP").each(function() {
					$(this).width((tableWidth * (parseInt($(this).attr("pgOFP")) / 100) - 10));
				});
			};
			
			this.doneLoading = function() {
				provcommon.runFunction(_options.doneCallback);
			};
			
			this.buildTitleBar = function(){
				var newButtons;
				if(_options.iconCreate==""){
					newButtons="";
				}
				else{
					newButtons = _me.createButtons(_options.iconCreate);
				}
				var headerHTML="<table class='GridHeader' cellspacing='0' cellpadding='0' border='0'>" +
					"<tbody>" +
						"<tr>" +
							"<th class='HeaderLeft exp'><img border='0' src='provenir/grid/images/grid_spacer.gif'/></th>" +
							"<th class='HeaderTitle'><span class='titleLeft'>" + _options.title+"</span>" +newButtons+ "</th>";
				// Checks to see if the content is hidden by default or not. If
				// true means the content is not hidden
				if(_options.contentVisible){
					headerHTML+=((_options.collapse != "no") ? "<th class='HeaderButton'><img border='0' src='provenir/grid/images/expandGrid.png' title='show content' /></th>" : "" ) +
							"<th class='HeaderRight'><img border='0' src='provenir/grid/images/grid_spacer.gif'/></th>" +
						"</tr>" 
					"</tbody>" +					
				"</table>";
				}
				else{
					headerHTML+=((_options.collapse != "no") ? "<th class='HeaderButton exp'><img border='0' src='provenir/grid/images/collapseGrid.gif' title='hide content'/></th>" : "" ) +
							"<th class='HeaderRight'><img border='0' src='provenir/grid/images/grid_spacer.gif'/></th>" +
						"</tr>" + 
					"</tbody>" +					
				"</table>";
				}
				_container.find('.GridContent').before(headerHTML);
				
				_container.find('.HeaderButton').click(function(){					
					if ($(this).hasClass('exp')){
						_container.find('div').hide();
						$(this).removeClass('exp');
						$(this).addClass('col');
						$(this).find('img').attr({src:'provenir/grid/images/expandGrid.png',title:'show content'});
					}
					else{
						_container.find('div').show();
						$(this).removeClass('col');
						$(this).addClass('exp');
						$(this).find('img').attr({src:'provenir/grid/images/collapseGrid.gif',title:'hide content'});
					}
				});
			}
			
			this.alternate = function() {
				if (_options.alternateRowColors)
				{
					_container.find('table.scroll').each(function(){
						var even = false;
						$(this).find('tr:gt(0):visible').each(function(i){
							if ($(this).attr("id") != "pgexpanded")
								even = !even;

							$(this).addClass(even ? "even" : "odd");
							$(this).removeClass(even ? "odd" : "even");
						});
					});
				}
			};
									
			this.resize = function(){			
				var $gridHeader = _container.find('.ColumnHeader');
				var $gridCols = $gridHeader.find('span');
				
				var $t;
				var $p;
				$gridCols.find('span').each(function(){
					$t = $(this);
					$p = $t.parent();
					$t.remove();
				});

				var cnt = $gridCols.length;
				var sum = 0;
				
				// Resize all column headers
				$gridCols.each(function(i){
					if (i == cnt - 1){
						var parWidth = parseFloat($(this).parent().width());
						$(this).css('width', (parseFloat( parseFloat(parWidth - sum - 2 - (cnt+1*2) + 1) / parWidth ) * 100 - 5) + "%");;
					}
					sum += parseFloat($(this).width());					
				});
				
				// Resize all the rows
				_container.find('.pgContentRow').each(function(){
					$(this).find('span').each(function(i){
						$(this).css('width', $gridHeader.find('span:eq('+ i + ')').css('width'));
					});
				});
				
				// readd the sort image
				if ($p){
					$p.append($t);
				}
			};		
			
			this.multiColumn = function(){				
				_container.find('tr.ColumnHeader').each(function(){
					$(this).addClass('visible');
				});
				
				_container.find('tr.ColumnHeader').click(function(){
					if ($(this).hasClass('visible')){
						$(this).removeClass('visible');						
						$(this).parent().find('tr:gt(0)').hide();
					}
					else{
						$(this).addClass('visible');
						if ($(this).parent().find('td.expRows').html()){
							$(this).parent().find('td.expRows').html($(this).parent().find('td.expRows').html().replace(_options.lessRowText, _options.moreRowText));
						}
						if (_options.hideContent){
							$(this).parent().find('tr:gt(0)').show();
							$(this).parent().find('tr:gt(0)').each(function(i){
								if ($(this).find('td.expRows').length > 0){
									$(this).show();
								}
								else{
									if (i > _options.maxRowSize - 1){									
										$(this).hide();
									}								
									else{
										$(this).show();
									}
								}
							});
						}
						else{
							$(this).parent().find('tr:gt(0)').show();
						}
					}
				});
			};
			
			this.makeHighlightable = function(){								
				_container.find('.ColumnContent').each(function(i){
						var _row = $(this);
						var _i = i;
						$(this).css("cursor", "pointer");
						$(this).mouseover(function(){
								_row.removeClass("even odd");
								_row.addClass("highlight");
						});			
						$(this).mouseout(function(){
								_row.removeClass("highlight");
								_row.addClass((_i%2 == 0) ? "even" : "odd");
						});			
				})
			};
			
			this.hideContent = function(){								
				var colspan = 0;	
				_container.find('table.scroll').each(function(){
					var hidden = false;
					var tbl = $(this);
					$(this).find('tr').each(function(i){
						colspan = $(this).find('td').length;
						if (i > _options.maxRowSize){
							$(this).hide();
							hidden = true;
						}
					});
					
					if (hidden){
						var newTR = $('<tr class="ColumnContent" style="text-align:right;"><td colspan=2 class="expRows" style="text-decoration:underline;color:blue;"><b>' + _options.moreRowText + '</b></td></tr>');						
						$(this).find('tbody').append(newTR);
						newTR.find('td.expRows').each(function(){
							$(this).css('cursor', 'pointer');
							$(this).mouseover(function(){
								$(this).css('background-color', 'white');
							});
							
							$(this).click(function(){								
								if ($(this).html().indexOf(_options.moreRowText) >= 0){
									tbl.find('tr').show();
									$(this).html($(this).html().replace(_options.moreRowText, _options.lessRowText));
								}
								else{
									tbl.find('tr:gt(' + _options.maxRowSize + ')').hide();
									$(this).parent().show();
									$(this).html($(this).html().replace(_options.lessRowText, _options.moreRowText));
								}
							});
						});
					}
				});
			};
			
			this.addSortSpan = function(o, spanClass)
			{
				return $('<span class="' + spanClass + ' pgColumnHdr">&nbsp;</span>').appendTo(o);
			};
			
			this.makeSortable = function(curSortField, curSortOrder){
				// For each pgColumnHdr th tag, call the function to strip the span tag within the th and call the performSort function					 	
				_container.find('th.pgSortable').each(function(){		
					// this is the object for .ColumnHeader th
					var th = $(this);
					
					if (_options.sort == true || _options.sort=="true")
					{
						th.css("cursor", "pointer");
						
						//Set the icons properly
						if (th.attr("id") == curSortField)
						{
							_me.addSortSpan(th, curSortOrder == "DESC" ? "desc" : "asc");
						}					
						$(this).click(function(){						
							if (_options.sort){							
								if ($(this).hasClass('noSort'))
									return;
								var $t = th.find('span.pgColumnHdr');
								var spanClass = "asc";
								
								if ($t != null)
								{
									if ($t.hasClass('asc'))
										spanClass = "desc";								
								}
								
								// Remove any spans already in place (possibly from other columns)
								th.parent().find("span.pgColumnHdr").remove();
								
								// append the span tag to the columnHeader th tag
								$t = _me.addSortSpan(th, spanClass);
								
								_me.performSort(th.prevAll('th').length, th.attr("id"), spanClass=="desc");
							}
							_options.sort = true;
						});
					}
					else
					{
						th.css("cursor", "default");	
					}
				});
				
			};
			
			this.performSortInPlace = function(colIndex, colSortVal, bDesc){
				var rows = new Array();
				_container.find('.pgContentRow').each(function(){					
					var row = { compVal: "", 
							    rowObj: $(this)
					};
					
					var compTd = $(this).find('td').eq(colIndex);
					var imgs = compTd.find("img");
					if (imgs.length > 0) {
						row.compVal = imgs.eq(0).attr("title");
					} else {					
						var text = compTd.text();
						if (text != ""){
							if (!isNaN(text) && !parseInt(text) == "NaN")							
								text = parseInt(text);
							row.compVal = text;
						}
					}
					rows.push(row);
				});
				
				// perform sort
				if (bDesc){
					rows.sort(function(lhs, rhs){
						var lhsVal = lhs.compVal;
						var rhsVal = rhs.compVal;
						if (lhsVal > rhsVal)
							return -1;
						else if (lhsVal < rhsVal)
							return 1;
						else
							return 0;
					});
				}
				else{
					rows.sort(function(lhs, rhs){
						var lhsVal = lhs.compVal;
						var rhsVal = rhs.compVal;
						if (lhsVal > rhsVal)
							return 1;
						else if (lhsVal < rhsVal)
							return -1;
						else
							return 0;
					});
				}
				
				// apply Sort
				var tbody = _container.find("tbody");
				for (var idx in rows) {
					var row = rows[idx];
					tbody.prepend(row.rowObj);
				}
				_me.alternate();
			};
			
			this.performSort = function(colIndex, colSortVal, bDesc){
				
				// See if we need to do a postback
				if (_options.sortUrl != null && 
					_options.updateDivSelector != null &&
					_options.updateBusyDivSelector != null &&
					_options.sortUrl != null &&
					_options.sortParam != null &&
					_options.sortOrderByParam != null)
				{
					provajax.load(_options.updateDivSelector, _options.updateBusyDivSelector, _options.sortUrl + "&" + _options.sortParam + "=" + colSortVal + "&" + _options.sortOrderByParam + "=" + (bDesc == true ? "DESC" : "ASC"));
				}
				else
					_me.performSortInPlace(colIndex, colSortVal, bDesc);
			};
			

			this.toggleShowMoreText = function() {
				$(_options.showMoreLinkSelector + "Lbl").toggle();
				$(_options.showMoreLinkSelector).toggle();
			};
			
			this.showMore = function() {
				if (_showingMore) 
					return;
				_showingMore = true;
				_me.toggleShowMoreText();
				_page++;

				//Create temporary div
				var tempDivId = "tpage" + _container.attr('id')  + _page;
				_container.find("tbody").append("<div id='" + tempDivId + "'></div>");
				provajax.get(_options.updateBusyDivSelector, _options.showMoreUrl + '&' + _options.pageParam + '=' + _page, false,
						function(data){
							if (data.trim() == "")
							{
								//Remove link text and unbind event
								$(_options.showMoreLinkSelector + "Lbl").hide();
								$(_options.showMoreLinkSelector).hide();
								$(_options.onscrollObj).unbind("scroll");
							}
							else
							{
								_me.toggleShowMoreText();
								$("#" + tempDivId).replaceWith(data);
								_me.alternate();
								_me.doneLoading();
							}
							_showingMore = false;
						});					
			};
				
			this.setShowMore = function(){
				if (_options.onscrollObj)
				{
					$(_options.onscrollObj).scroll(function(){
						if (_options.height != null && _options.height != "100%" && _options.height != "auto") {
							//Use the container's scrollbar as a gauge
							if (container.scrollTop() >= container[0].scrollHeight - container.height() && _scrolled != container.scrollTop()) {
								_me.showMore();
								_scrolled = container.scrollTop();
							}
						} else {
							//Use the window's scrollbar as a gauge
							if  ($(window).scrollTop() >= $(document).height() - $(window).height() - 150 && _scrolled != container.scrollTop()) {
								_me.showMore();
								_scrolled = container.scrollTop();
							}
						}
					}); 
				}
				
				$(_options.showMoreLinkSelector).click(function(){
					_me.showMore();
				});
			};
			
			//Binds to all expand buttons. When clicked, show a loading image and make the appropriate load command
			this.bindExpandButtons = function(){
				_container.find("img[id=pgexpand]").each(function() {
					var parentTd = $(this).closest('td');
					var parentTr = $(this).closest('tr');
					var img = $(this);
					parentTd.click(function() {
						var expanded = img.attr("src").contains("minus");
						var previouslyExpanded = img.hasClass("exp") || img.hasClass("coll"); 
						
						var childRow;
						if (!expanded) {
							img.removeClass("coll").addClass("exp");
							img.attr("src", img.attr("src").replace("plus", "minus"));

							if (!previouslyExpanded) {
								var numCols = 0;
								parentTr.find("td").each(function(){
									numCols += $(this).attr("colspan") ? parseInt($(this).attr("colspan")) : 1;
								});
								var parentClass = parentTr.attr("class") ? parentTr.attr("class") : ""; 					
								var html = "<tr class='" + parentClass + "' id='pgexpanded'><td colspan='" + numCols + "'><div id='loader' style='display:none;padding:10px'><img src='js/provenir/base/grid/images/expandLoader.gif'/></div><div style='display:none'/></td></tr>";					
								childRow = parentTr.after(html).next();
								
								childRow.find("div[id=loader]").slideDown(500, function() {
									//Start AJAX call
									var loaderDiv = $(this);
									var loadIntoDiv = $(this).next();
									provajax.loadFromUrl(loadIntoDiv, img.attr("url"), img.attr("type"), function() {
										loaderDiv.slideUp(500, function() {
											loaderDiv.remove();
											loadIntoDiv.slideDown(500);
										});
									});
								});
								
							} else {
								childRow = parentTr.next();
								childRow.find("div").parent().show();
								childRow.find("div").slideDown(500);
							}							
						} else {
							childRow = parentTr.next();
							img.removeClass("exp").addClass("coll");
							img.attr("src", img.attr("src").replace("minus", "plus"));
							childRow.find("div").slideUp(500, function() {
								$(this).parent().hide();
							});
						}
												
					});					
				});
			};
			
			this.numRows = function() {
				return _container.find("tr").not("#pgexpanded").length;
			};
			
			this.bindAddButton = function() {
				$(document).find(_options.addButtonSelector).click(function() { 					 
					var html = _options.addButtonHtml.replace('\\"', '\"');					
					//if nested dynamic add is found, save the Inner Index within script before global replacement
					var start = html.indexOf('<script');
					
					if(start!=-1)
					{
					var origHtml=html;
					
					regExpStart = /<script/g;
					regExpEnd = /script>/g;
					
					numOfDynamic= html.match(/<script/g).length;
					var startIndexes= new Array(numOfDynamic);
					var endIndexes= new Array(numOfDynamic);
					var htmlTemps= new Array(numOfDynamic);
					var anchorNames = new Array(numOfDynamic);
					var guidNames = new Array(numOfDynamic);
					
					
					i=0;
					while(mStart = regExpStart.exec(html)){
						startIndexes[i]=mStart.index;
						i++;
					}
					
					i=0;
					while(mEnd = regExpEnd.exec(html)){
						endIndexes[i]= mEnd.index + (("/script>").length-1); //get the /script> back
						i++;
					}
					

					for(i=0; i<numOfDynamic; i++)
					{
						htmlTemps[i] = html.substring(startIndexes[i],endIndexes[i]).replace(/~%INDEX%~/g, (_me.numRows()-1)+"~\%INNERINDEX\%~");
											
						//need to make the anchor name unique for each add
						var anchorName = htmlTemps[i].replace(/^.*addButtonSelector:(.*),showMoreLinkSelector.*$/m,"$1");
					
						anchorNames[i]=anchorName.substring(3, anchorName.length-1);
						
						
						//need to make the init script unique for each add
						guidNames[i] = htmlTemps[i].replace(/^.*init(.*)\(\).*$/m,"$1");
						
						
						//change the script into INNERscript to avoid it is executed instead of passing the text as we need
						htmlTemps[i] = htmlTemps[i].replace(/script/g,"INNERscript");
					}

					//at last, compose the html back from pieces
					
//						html = html.substring(0, startIndexes[0])+ htmlTemps[0] + html.substring(endIndexes[0], startIndexes[1]) + htmlTemps[1] + html.substring(endIndexes[1]);
						
						
						htmlNew = html.substring(0, startIndexes[0])+ htmlTemps[0];
						for(i=0; i<numOfDynamic-1; i++)
						{				
							htmlNew = htmlNew + html.substring(endIndexes[i], startIndexes[i+1]) + htmlTemps[i+1] ;		
						}
						htmlNew = htmlNew + html.substring(endIndexes[numOfDynamic-1]);
						html=htmlNew;
						
						//the anchor needs to be replaced globally
						for(i=0; i<numOfDynamic; i++)
						{
						var anchorExp = new RegExp(anchorNames[i],"g");				 
						var newAnchor = anchorNames[i] + "_" + (_me.numRows()-1);
						html= html.replace(anchorExp, newAnchor);
						
						
						var guidExp = new RegExp(guidNames[i],"g");					 
						var newGuid = guidNames[i] + "_" + (_me.numRows()-1);
						html= html.replace(guidExp, newGuid);
						
						}
	
					}		 
					else 	html = html.replace(/~%INDEX%~/g, "" + (_me.numRows()-1));
					
					html = html.replace(/~%INDEX%~/g, "" + (_me.numRows()-1));
					html = html.replace(/~%INNERINDEX%~/g, "~\%INDEX\%~");
					
					if (_options.prepend == true || _options.prepend=="true")
					{
						provtable.addRow(_container.find(">table"), html, true);
					}
					else
					{
						provtable.addRow(_container.find(">table"), html, false);
					}
					_me.alternate();
				});
			}
			
			// Resize the columns on window resize
			$(window).resize(function(){
				_me.resize();
			});
			

		this.onEnter();
	}
	
	$.fn.provGrid = function(options) {
		$(this).each(function() {
			return new ProvGrid($(this), options);
		});
	};
})(jQuery);